import { ProduceCategory } from "../types/Produce";

export const suggestionVariantMap: { [key in ProduceCategory]: string } = {
	[ProduceCategory.RowCrop]: "success",
	[ProduceCategory.Legumes]: "warning",
	[ProduceCategory.GrassesAndCereals]: "danger",
	[ProduceCategory.GreenManure]: "primary",
};
